import { backendApi } from "./APIs";
import { getUser, removeUserSession } from "./Common";

export const Post = async (url, args = {}, method = "POST", loader = false) => {
   if (!["POST", "GET"].includes(method)) method = "POST";

   var user = getUser();
   if (user) {
      args.token = user.token;
   }
   if (loader) loader(true);
   try {
      let resp = method === "POST" ? await backendApi.post(url, args) : await backendApi.get(url, args);
      if (loader) loader(false);
      if (!resp.data || (method === "POST" && resp.data.msj === null)) return { estatus: false, msj: "Ocurrió un problema al obtener los datos, verifique la compatibilidad con el metodo post" };
      return method === "POST" ? resp.data : { estatus: true, msj: "Datos get obtenidos", data: resp.data };
   } catch (error) {
      if (loader) loader(false);
      if (error.response && error.response.status === 401) {
         removeUserSession();
         window.location.reload();
      }
      // Maneja cualquier error que ocurra durante la solicitud
      return { estatus: false, msj: "Ocurrió un problema al obtener los datos, verifique la API" };
   }
}

export default Post;